<div class="product_desc affirm-div">
  <p class="affirm-as-low-as mb-0" data-page-type="product" [attr.data-amount]="amount" data-affirm-color="black"></p>
</div>